document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-bk-flip-card]').forEach(function (card) {
    var front = card.querySelector('.bk55-flip-front');
    var back = card.querySelector('.bk55-flip-back');
    var openButton = front.querySelector('[data-bk-flip-toggle]');
    var closeButton = back.querySelector('[data-bk-flip-toggle]');
    var backLink = back.querySelector('a');
    function setFlipped(flipped) {
      card.classList.toggle('is-flipped', flipped);
      front.setAttribute('aria-hidden', flipped ? 'true' : 'false');
      back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
      openButton.setAttribute('aria-expanded', flipped ? 'true' : 'false');
      openButton.tabIndex = flipped ? -1 : 0;
      closeButton.tabIndex = flipped ? 0 : -1;
      if (backLink) backLink.tabIndex = flipped ? 0 : -1;
      if (flipped) closeButton.focus({preventScroll:true});
      else openButton.focus({preventScroll:true});
    }
    openButton.addEventListener('click', function () { setFlipped(true); });
    closeButton.addEventListener('click', function () { setFlipped(false); });
    card.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && card.classList.contains('is-flipped')) setFlipped(false);
    });
  });
});
